import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import CtaPrimary from 'components/ui/CtaPrimary';
import { PageContainer, PageHeaderTitle, PageHeaderDetails } from '../../common/Page';

const StyledCtaPrimary = styled(CtaPrimary)`
  background-color: ${colors.LIGHT_BLUE_GREY};
  color: ${colors.ULTRAMARINE_BLUE};
  margin-top: 64px;
  width: fit-content;
  ${media.mobile`
    margin-top: 40px;
  `};
`;

const EmptyRenewalPage = ({ handleRetry }) => {
  return (
    <PageContainer>
      <PageHeaderTitle>
        {getTranslatedString('landlordPortal.rentRoll.renewals.missedAStep')}
      </PageHeaderTitle>
      <PageHeaderDetails>
        {getTranslatedString('landlordPortal.rentRoll.renewals.unableToFindRenewalDetailsYardi')}
      </PageHeaderDetails>
      <StyledCtaPrimary type="button" onClick={() => handleRetry()}>
        {getTranslatedString('landlordPortal.rentRoll.renewals.syncYardiUpdates')}
      </StyledCtaPrimary>
    </PageContainer>
  );
};

export default EmptyRenewalPage;
